module.exports = __webpack_public_path__ + "static/media/soap-pn.598f6c75.png";